import React from 'react';
import ReactDomServer from 'react-dom/server';
import { sprintf } from 'sprintf';

import { SidebarWidget } from 'playlists/components/SidebarWidget';

const starHTML = ReactDomServer.renderToString(
  <span
    className='icon-vault-alternative'
    style={{
      fontSize: 12,
      marginRight: 4,
      position: 'relative',
    }}
  />,
);

export const SidebarMasterPlaylistTip = () => (
  <SidebarWidget className='sidebar-widget--tip' title='Tips'>
    <p
      className='vault-tip-text'
      dangerouslySetInnerHTML={{
        __html: sprintf(
          '%s playlist contains all the artworks that you have purchased. It is available for playback on every Sedition app. Artworks in this playlist can only be reordered.',
          `${starHTML}<b>${'Owned Artworks'}</b>`,
        ),
      }}
    />
  </SidebarWidget>
);
